export const initialise = () => {
    const widgets = document.querySelectorAll<HTMLDivElement>('.attrax-list-widget')
    
    widgets.forEach((widget: HTMLDivElement) => {
        if (!widget.querySelector('.attrax-list-widget__list--has-items')) return
        const button = widget.querySelector<HTMLAnchorElement>('.attrax-list-widget__readmore.attrax-button')
        if (!button) return
        const container = widget.querySelector<HTMLDivElement>('.attrax-list-widget__lists')
        if (!container) return
        container.appendChild(button)
    })
}